<template>
    <div id="company-title" class="title bg-success">
        <div>Playbooks Compartilhados</div>
    </div>

    <PaginateTable :items="playbooks" :reversed="true" v-slot="{ paginatedItems }">
        <table class="table table-sm">
            <thead class="table-light">
                <tr>
                    <th scope="col" class="col-id">ID</th>
                    <th scope="col" class="col-name">Nome</th>
                    <th scope="col" class="col-actions">Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="playbook in paginatedItems" :key="playbook.id">
                    <td style="vertical-align: middle;">{{ playbook.id }}</td>
                    <td style="vertical-align: middle;">{{ playbook.name }}</td>
                    <td class="text-center" style="vertical-align: middle;">
                        <div class="d-flex gap-1">
                            <router-link v-if="isEditing.value" :to="`/playbooks/${playbook.id}?mode=edit`">
                                <button type="button" class="actions btn btn-primary btn-sm">
                                    Editar
                                </button>
                            </router-link>
                            <router-link v-if="!isEditing.value" :to="`/playbooks/${playbook.id}?mode=view`">
                                <button type="button" class="actions btn btn-info btn-sm">
                                    Visualizar
                                </button>
                            </router-link>
                            <button v-if="isEditing.value" @click="() => playbook.isDeleting = true" type="button"
                                class="actions btn btn-danger btn-sm">
                                Excluir
                            </button>
                            <ModalContent :is-modal-open="playbook.isDeleting"
                                @close="() => playbook.isDeleting = false" @send="() => {
                                    deletePlaybook(playbook.id);
                                    playbook.isDeleting = false
                                }" :title="`Excluir playbook ?`">Você tem certeza que deseja excluir esse playbook?
                            </ModalContent>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </PaginateTable>
    <button v-if="isEditing.value" @click="addPlaybook" type="button" class="mx-auto actions btn btn-primary btn-sm">
        Adicionar
    </button>
</template>

<script>
import PaginateTable from '@/components/PaginateTable.vue'
import ModalContent from '@/components/ModalContent.vue';
import { playbookService } from '@/services/backend/ApiService';

export default {
    components: {
        PaginateTable,
        ModalContent
    },
    data() {
        return {
            playbooks: [],
            isEditing: { value: true },
        };
    },
    async mounted() {
        this.playbooks = await playbookService.findAll({
            shared: true
        });
    },
    methods: {
        async addPlaybook() {
            const newPlaybook = {
                name: "Novo Playbook",
                shared: true,

            };

            const createdPlaybook = await playbookService.create(newPlaybook);
            this.playbooks.push(createdPlaybook);
        },
        async deletePlaybook(id) {
            await playbookService.delete(id);
            this.playbooks = this.playbooks.filter((playbook) => playbook.id !== id);
        },
    },
};
</script>

<style scoped>
.col-id {
    min-width: 60px;
} 

.col-name{
    width: 100%;
}
</style>